import { ChatBubbleOutline, Close, WhatsApp } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { useState } from "react";

const BOTPRESS_CHAT_URL =
  "https://cdn.botpress.cloud/webchat/v3.6/shareable.html?configUrl=https://files.bpcontent.cloud/2026/04/26/05/20260426052507-CEG7PNQB.json";

export default function BotonWsp() {
  const [chatOpen, setChatOpen] = useState(false);

  const floatingButtonStyles = {
    width: { xs: 56, md: 64 },
    height: { xs: 56, md: 64 },
    backgroundColor: "rgba(255,255,255,0.92)",
    border: "1px solid rgba(255,255,255,0.82)",
    boxShadow: "0 18px 45px rgba(24,34,54,0.18)",
    backdropFilter: "blur(12px)",
    transition: "transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.98)",
      transform: "translateY(-4px) scale(1.03)",
      boxShadow: "0 24px 58px rgba(24,34,54,0.24)",
    },
  };

  const floatingLabelStyles = {
    mt: 0.35,
    px: 0.75,
    py: 0.15,
    borderRadius: "999px",
    backgroundColor: "rgba(255,255,255,0.78)",
    boxShadow: "0 8px 24px rgba(24,34,54,0.1)",
    backdropFilter: "blur(10px)",
    fontSize: "0.64rem",
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "0.01em",
  };

  return (
    <MKBox
      position="fixed"
      bottom={{ xs: 16, md: "5%" }}
      right={{ xs: 16, md: "5%" }}
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      gap={1.25}
      sx={{
        zIndex: 1300,
      }}
    >
      {chatOpen && (
        <MKBox
          sx={{
            width: { xs: "calc(100vw - 2rem)", sm: 390 },
            height: { xs: "70vh", md: 640 },
            maxHeight: "calc(100vh - 7.5rem)",
            overflow: "hidden",
            borderRadius: "28px",
            backgroundColor: "rgba(255,255,255,0.96)",
            border: "1px solid rgba(255,255,255,0.86)",
            boxShadow: "0 28px 80px rgba(18, 27, 44, 0.28)",
            backdropFilter: "blur(18px)",
          }}
        >
          <MKBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={2}
            py={1.25}
            sx={{
              borderBottom: "1px solid rgba(62, 161, 236, 0.14)",
              color: "primary.main",
              fontWeight: 700,
            }}
          >
            Asistente virtual
            <IconButton
              aria-label="Cerrar asistente virtual"
              size="small"
              onClick={() => setChatOpen(false)}
            >
              <Close fontSize="small" />
            </IconButton>
          </MKBox>
          <MKBox
            component="iframe"
            title="Asistente virtual"
            src={BOTPRESS_CHAT_URL}
            loading="lazy"
            sx={{
              display: "block",
              width: "100%",
              height: "calc(100% - 49px)",
              border: 0,
              backgroundColor: "white",
            }}
          />
        </MKBox>
      )}

      <MKBox display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start" gap={1}>
        <MKBox display="flex" flexDirection="column" alignItems="center">
          <Tooltip
            placement="top"
            title={chatOpen ? "Cerrar asistente virtual" : "Abrir asistente virtual"}
          >
            <IconButton
              aria-label={chatOpen ? "Cerrar asistente virtual" : "Abrir asistente virtual"}
              onClick={() => setChatOpen((current) => !current)}
              sx={({ palette: { primary } }) => ({
                ...floatingButtonStyles,
                color: chatOpen ? "white" : primary.main,
                backgroundColor: chatOpen ? primary.main : floatingButtonStyles.backgroundColor,
                "&:hover": {
                  ...floatingButtonStyles["&:hover"],
                  backgroundColor: chatOpen ? primary.focus : "rgba(255,255,255,0.98)",
                },
              })}
            >
              {chatOpen ? <Close fontSize="large" /> : <ChatBubbleOutline fontSize="large" />}
            </IconButton>
          </Tooltip>
          <MKTypography
            variant="caption"
            color={chatOpen ? "primary" : "dark"}
            sx={floatingLabelStyles}
          >
            Chatbot
          </MKTypography>
        </MKBox>
        <MKBox display="flex" flexDirection="column" alignItems="center">
          <Tooltip placement="top" title="Contactar por Whatsapp">
            <IconButton
              aria-label="Contactar por Whatsapp"
              sx={{
                ...floatingButtonStyles,
                color: "#2fb344",
              }}
              onClick={() => {
                window.open("https://wa.link/q81tly", "_blank", "noopener,noreferrer");
              }}
            >
              <WhatsApp fontSize="large" />
            </IconButton>
          </Tooltip>
          <MKTypography variant="caption" color="dark" sx={floatingLabelStyles}>
            WhatsApp
          </MKTypography>
        </MKBox>
      </MKBox>
    </MKBox>
  );
}
